import Logout from '../../../Assets/Logout.svg';

export const studentNavlinks = [
  {
    name: 'Jobs',
    link: '/hiring/student/findjob',
  },
  {
    name: 'My Application',
    link: '/hiring/student/myapplication',
  },
  {
    name: 'Invites',
    link: '/hiring/student/invites',
    break: true,
  },
  {
    name: 'Saved Jobs',
    link: '/hiring/student/savejobs',
  },
  {
    name: 'Message',
    link: '/hiring/student/chat',
    break: true,
  },
  {
    name: 'View Profile',
    link: '/hiring/student/profile',
  },
  {
    name: 'Change Password',
    link: '/hiring/student/change_password',
  },
  {
    name: 'Logout',
    link: '/student/home',
    isLogout: true,
    img: Logout,
  },
];
export const recruiterNavlinks = [
  {
    name: 'Job Posts',
    link: '/hiring/recruiter/active',
  },
  {
    name: "Find Talent",
    link: "/hiring/recruiter/findtalent",
    break: true,
  },
  // {
  //   name: "Notifications",
  //   link: "",
  // },
  {
    name: "Messages",
    link: "/hiring/recruiter/chat",
    break: true,
  },
  {
    name: "View Profile",
    link: "/hiring/recruiter/profile",
  },
  {
    name: "Change Password",
    link: "/hiring/recruiter/change_password",
  },
  {
    name: "Logout",
    link: "/",
    isLogout: true,
  },  
];
